import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
//import { compose } from "recompose";

//import { withFirebase } from "../Firebase";
import { doLogIn } from "../DataNet/DataNetAuth";
import * as ROUTES from "../../constants/routes";
import { Button, CircularProgress, Divider, Grid, IconButton, InputAdornment, TextField, Typography, FormHelperText, makeStyles } from "@material-ui/core";
import { AccountCircle, Instagram, LinkedIn, Lock, Twitter, Visibility, VisibilityOff, YouTube } from "@material-ui/icons";

import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BexenCardioLogo from "../../assets/images/0_3_BEXEN_Cardio_Horiz.png";
import LangSelect from "../Navigation/LangSelect";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";

const INITIAL_STATE = {
    email: "",
    password: "",
    error: null,
};

const getRedirectToAfterLogin = () => {
    const redirectTo = sessionStorage.getItem("rdnRedirectTo");

    if (
        redirectTo &&
        redirectTo.startsWith("/") &&
        !redirectTo.startsWith("//") &&
        redirectTo !== ROUTES.SIGN_IN &&
        redirectTo !== ROUTES.TWO_FACTOR_VERIFY
    ) {
        return redirectTo;
    }

    return ROUTES.HOME;
};

const SignInForm = () => {
    const history = useHistory();
    const location = useLocation();
    // const { t, i18n } = useTranslation();
    const { t } = useTranslation();
    const classes = useStyles();

    const [openSuccessSnack, setOpenSuccessSnack] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [email, setemail] = useState(INITIAL_STATE.email);
    const [emailError, setEmailError] = useState(null);
    const [password, setpassword] = useState(INITIAL_STATE.password);
    const [error, setError] = useState(INITIAL_STATE.error);
    const [isSessionLoading, setIsSessionLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // useEffect(() => {
    //     i18n.changeLanguage("en");
    // }, [i18n]);
    useEffect(() => {
        if (location.state?.successMessage) {
            setSuccessMessage(location.state.successMessage);
            setOpenSuccessSnack(true);

            // Limpiar el estado del historial para evitar que el mensaje 
            // vuelva a salir si el usuario recarga la página (F5)
            window.history.replaceState({}, document.title);
        }
    }, [location]);

    const onSubmit = (event) => {
        event.preventDefault();

        setIsSessionLoading(true);

        const redirectTo = getRedirectToAfterLogin();

        sessionStorage.removeItem("a2fInProgress");
        sessionStorage.removeItem("a2fChallengeId");
        sessionStorage.removeItem("a2fExpiresInSeconds");
        sessionStorage.removeItem("a2fRedirectTo");
        sessionStorage.removeItem("a2fDefaultLang");

        doLogIn(email, password)
            .then((snap) => {
                if (snap?.status?.first_login) {
                    history.push(ROUTES.REQUEST_NEW_PASSWROD);
                    return;
                }
                if (snap?.status?.mfaRequired) {
                    const defaultLang =
                        snap?.status?.defaultLang ||
                        snap?.status?.default_lang ||
                        "es";

                    sessionStorage.setItem("a2fInProgress", "true");
                    sessionStorage.setItem("a2fChallengeId", snap.status.challengeId);
                    sessionStorage.setItem("a2fExpiresInSeconds", snap.status.expiresInSeconds);
                    sessionStorage.setItem("a2fRedirectTo", redirectTo);
                    sessionStorage.removeItem("rdnRedirectTo");
                    sessionStorage.setItem("a2fDefaultLang", defaultLang);

                    history.push({
                        pathname: ROUTES.TWO_FACTOR_VERIFY,
                        state: {
                            challengeId: snap.status.challengeId,
                            expiresInSeconds: snap.status.expiresInSeconds,
                            email,
                            redirectTo,
                            defaultLang,
                        },
                    });

                    return;
                }

                sessionStorage.removeItem("rdnRedirectTo");
                window.location.href = redirectTo;
            })
            .catch((error) => {
                setIsSessionLoading(false);
                switch (error) {
                    case 1:
                        setError(t("signIn.error.wrongLogin"));
                        break;
                    case 3:
                        setError(t("signIn.error.wrongLogin"));
                        break;
                    case 2:
                        setError(t("signIn.error.userBlock"));
                        break;
                    case -1:
                        setError(t("signIn.error.serverError"));
                        break;
                    default:
                        setError(t("signIn.error.serverError"));
                        break;
                }
            });

        event.preventDefault();
    };

    const checkEmail = () => {
        const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        !new RegExp(emailPattern).test(email) && email !== "" && setEmailError(t("account.error.format_email"));
    };

    const onEmailChange = (event) => {
        setemail(event.target.value.trim());
        setError(null);
        setEmailError(null);
    };

    const onPasswordChange = (event) => {
        setpassword(event.target.value);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const isInvalid = isSessionLoading || password === "" || email === "" || !!emailError;

    return (
        <>
        <form onSubmit={onSubmit}>
            <Grid container justify="center" alignItems="center" spacing={4}>
                <Grid item xs={12} justify="center" className={classes.title}>
                    <Typography variant="h4" component="h1" gutterBottom color="secondary" style={{ marginBottom: 0, fontWeight: 500, fontSize: "2.3rem" }}>
                        REANIBEX DATA NET
                    </Typography>
                    <Grid container direction="row" alignContent="flex-end">
                        <Grid item>
                            <Typography
                                variant="h6"
                                gutterBottom
                                color="secondary"
                                style={{
                                    fontSize: 18,
                                    //  color: "grey",
                                    fontWeight: 600,
                                    marginTop: 5,
                                    marginRight: 4,
                                }}
                            >
                                by
                            </Typography>
                        </Grid>

                        <Grid item>
                            <img src={BexenCardioLogo} style={{ width: 148 }} />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container item xs={12} sm={12} md={9} xl={9} spacing={2} justify="center">
                    <Grid item xs={12} sm={7} md={12} xl={12}>
                        <TextField
                            id="email"
                            variant="outlined"
                            name="email"
                            error={!!emailError || error}
                            value={email}
                            onBlur={checkEmail}
                            onChange={onEmailChange}
                            type="text"
                            label={t("common.email")}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AccountCircle color="primary" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Grid item xs={12} sm={7} md={12} xl={12}>
                            <FormHelperText error>{emailError}</FormHelperText>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={5} md={12} xl={12}>
                        <TextField
                            id="password"
                            variant="outlined"
                            name="password"
                            value={password}
                            error={error}
                            onChange={onPasswordChange}
                            type={showPassword ? "text" : "password"}
                            label={t("common.password")}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Lock color="primary" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                                        {showPassword ? <Visibility color="primary" /> : <VisibilityOff />}
                                    </IconButton>
                                ),
                            }}
                        />
                    </Grid>
                    {error && (
                        <Grid item xs={12} sm={5} md={12} xl={12}>
                            <Typography variant="body2" color="error">
                                {error}
                            </Typography>
                        </Grid>
                    )}
                </Grid>

                <Grid container item xs={12} md={9} spacing={2} justify="center">
                    <Grid item xs={12} sm={6} md={12} container justify="center">
                        {isSessionLoading ? (
                            <CircularProgress style={{ j: "center" }} />
                        ) : (
                            <Button size="medium" fullWidth variant="contained" disabled={isInvalid} style={{ textTransform: "none" }} color={"secondary"} type="submit">
                                {t("common.dologin")}
                            </Button>
                        )}
                    </Grid>

                    <Grid item xs={12} sm={6} md={12}>
                        <Link to={ROUTES.ACCOUNT_NEW} style={{ textDecoration: "none" }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="medium"
                                fullWidth
                                style={{ textTransform: "none" }}
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                {t("common.createAccount")}
                            </Button>
                        </Link>
                    </Grid>
                    {
                        <Grid item xs={12} sm={6} md={12}>
                            <Button style={{ marginTop: 8, textTransform: "none" }} onClick={() => history.push(ROUTES.REQUEST_NEW_PASSWROD)} fullWidth>
                                {t("passwordForgot")}
                            </Button>
                        </Grid>
                    }
                </Grid>

                <Grid item xs={8} style={{ width: "100%" }}>
                    <Divider />
                </Grid>
                <Grid container item xs={12} direction="row" justify="center" alignItems="center" style={{ width: "100%" }}>
                    {/* <Grid item container xs={3} justify="center" alignItems="center">
            <IconButton color="secondary" onClick={() => window.open("https://twitter.com/BexenCardio", "_blank")}>
              <Twitter fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item container xs={3} justify="center" alignItems="center">
            <IconButton color="secondary" onClick={() => window.open("https://www.instagram.com/bexencardio/", "_blank")}>
              <Instagram fontSize="large" />
            </IconButton>
          </Grid> */}
                    <Grid item container xs={3} justify="center" alignItems="center">
                        <IconButton color="secondary" onClick={() => window.open("https://www.linkedin.com/company/bexen-cardio/", "_blank")}>
                            <LinkedIn fontSize="large" />
                        </IconButton>
                    </Grid>

                    <Grid item container xs={3} justify="center" alignItems="center">
                        <IconButton color="secondary" onClick={() => window.open("https://www.youtube.com/channel/UCqkQ7fCHKFMVOc7jv5xffqw", "_blank")}>
                            <YouTube fontSize="large" />
                        </IconButton>
                    </Grid>

                </Grid>
            </Grid>
        </form>
        <Snackbar
            open={openSuccessSnack}
            autoHideDuration={5000}
            onClose={() => setOpenSuccessSnack(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert onClose={() => setOpenSuccessSnack(false)} severity="success" variant="filled">
                {successMessage}
            </Alert>
        </Snackbar>
        </>
    );
};

export default SignInForm;

const useStyles = makeStyles((theme) => ({
    title: {
        [theme.breakpoints.down("sm")]: {
            marginLeft: theme.spacing(2),
        },
    },
}));
